module.exports = __webpack_public_path__ + "static/img/039安监大数据平台.def9787.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/039安监大数据平台.jpg
// module id = OaaS
// module chunks = 0